import React from 'react';
import * as clipboardPolyfill from 'clipboard-polyfill/dist/clipboard-polyfill.promise';
import ShareModalDrawerTextMessage from 'components/MainActionBar/ShareModalDrawerTextMessage';
import Modal from '../../../../components/shared/Modal';
import ShareModalDrawer from '../../../../components/shared/ShareModalDrawer';
import { ShareModalDrawerEmbed } from './share_modal_drawer_embed';
import { ShareModalDrawerQRCode } from './share_modal_drawer_qrcode';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const ShareModal = createReactClass({
  getInitialState() {
    return {
      checkmarks: {},
      openDrawer: null
    };
  },
  componentDidMount() {
    this.timers = {};
    _gaq.push(['_trackEvent', 'Share', 'modal-show', this.props.shareObject.type]);
  },
  openDrawer(drawer) {
    this.setState({ openDrawer: drawer });
    _gaq.push(['_trackEvent', 'Share', `${drawer}-show`, this.props.shareObject.type]);
  },
  closeDrawer() {
    this.setState({ openDrawer: null });
  },
  handleClose() {
    if (this.state.openDrawer) {
      this.closeDrawer();
    } else {
      this.props.handleClose();
    }
  },
  setCheckmark(item) {
    if (this.timers[item]) {
      clearTimeout(this.timers[item]);
    }
    const { checkmarks } = this.state;
    checkmarks[item] = true;
    this.setState({ checkmarks });
    this.timers[item] = setTimeout(() => {
      checkmarks[item] = false;
      this.setState({ checkmarks });
    }, 4000);
  },
  formatViewPath() {
    let pathStart;
    switch (this.props.shareObject.type) {
      case 'map':
        pathStart = 'explore/map/';
        break;
      case 'track':
        pathStart = 'explore/recording/';
        break;
      case 'list':
        pathStart = 'lists/';
        break;
      default:
        pathStart = '';
    }
    return `${pathStart}${this.props.shareObject.slug}`;
  },
  formatViewParams() {
    if (!this.props.currentUser) {
      return '';
    }
    return `?u=${this.props.currentUser.metric ? 'm' : 'i'}`;
  },
  formatViewUrl() {
    return `${location.protocol}//${location.host}/${this.formatViewPath()}${this.formatViewParams()}`;
  },
  handleCopyClick() {
    if (!this.props.clipboard) {
      alert(StringConstantsMixin.strings.SHARE_MODAL.COPY_NOT_AVAILABLE);
      return;
    }
    this.props.clipboard.writeText(this.formatViewUrl()).then(
      () => {
        this.setCheckmark('copy');
        _gaq.push(['_trackEvent', 'Share', 'link-copy', this.props.shareObject.type]);
      },
      err => {
        console.error('Could not copy link to clipboard: ', err);
      }
    );
  },
  isPrivateContent() {
    const shareObject = this.props.shareObject;
    const currentUser = this.props.currentUser;
    return ['map', 'track', 'list'].indexOf(shareObject.type) > -1 && (shareObject.private || (currentUser && currentUser.private));
  },
  offerEmbed() {
    return !this.isPrivateContent();
  },
  sendSMSMessage(phoneNumber, resource, languageRegionCode, onFailed) {
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/notifications/sms',
      {
        number: phoneNumber,
        resource_type: resource.type,
        resource_id: resource.id,
        resource_primary_key: resource.primaryKey,
        lang: languageRegionCode
      },
      () => {
        this.setCheckmark('sms');
        this.closeDrawer();
      },
      onFailed,
      () => {},
      {}
    );
  },
  handleEmailClick() {
    const subject = StringConstantsMixin.strings.SHARE_MODAL.CHECK_THIS_OUT_ON_ALLTRAILS;
    const body = `${StringConstantsMixin.strings.SHARE_MODAL.CHECK_THIS_OUT_ON_ALLTRAILS}:

${this.formatViewUrl()}

${StringConstantsMixin.strings.SHARE_MODAL.DOWNLOAD_THE_FREE_ALLTRAILS_APP}
https://alltrails.io/BrtlItRPbo`;

    _gaq.push(['_trackEvent', 'Share', 'email-show', this.props.shareObject.type]);
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
  },
  handleTextClick() {
    this.openDrawer('sms');
  },
  handleEmbedClick() {
    this.openDrawer('embed');
  },
  handleQRCodeClick() {
    this.openDrawer('qrcode');
  },
  formatFooter() {
    if (!this.state.openDrawer && this.isPrivateContent()) {
      return <p className="share-footer">{StringConstantsMixin.strings.SHARE_MODAL.PRIVATE_WARNING}</p>;
    }
    return null;
  },
  render() {
    let title;
    let content;
    let containerClass = '';

    switch (this.state.openDrawer) {
      case 'embed':
        title = StringConstantsMixin.strings.SHARE_MODAL[`EMBED_THIS_${this.props.shareObject.type.toUpperCase()}`];
        content = (
          <ShareModalDrawerEmbed
            clipboard={this.props.clipboard}
            currentUser={this.props.currentUser}
            shareObject={this.props.shareObject}
            locale={this.props.locale}
          />
        );
        break;
      case 'qrcode':
        title = StringConstantsMixin.strings.SHARE_MODAL.DOWNLOAD_QR_CODE;
        content = <ShareModalDrawerQRCode shareObject={this.props.shareObject} formatViewPath={this.formatViewPath} />;
        break;
      case 'sms':
        title = StringConstantsMixin.strings.SHARE_MODAL[`TEXT_THIS_${this.props.shareObject.type.toUpperCase()}`];
        content = <ShareModalDrawerTextMessage shareObject={this.props.shareObject} sendSMSMessage={this.sendSMSMessage} />;
        break;
      default:
        title = this.props.shareObject.type === 'map' ? StringConstantsMixin.strings.SHARE_MAP : StringConstantsMixin.strings.SHARE;
        const copyLinkTitle = this.state.checkmarks.copy
          ? StringConstantsMixin.strings.SHARE_MODAL.LINK_COPIED
          : StringConstantsMixin.strings.SHARE_MODAL.COPY_LINK;
        const smsTitle = this.state.checkmarks.sms
          ? StringConstantsMixin.strings.SHARE_MODAL.TEXT_SENT
          : StringConstantsMixin.strings.SHARE_MODAL.SEND_TEXT;
        let embedDiv = null;
        if (this.offerEmbed()) {
          embedDiv = (
            <div>
              <hr />
              <ShareModalDrawer
                title={StringConstantsMixin.strings.SHARE_MODAL.EMBED_WIDGET}
                imgLink="https://cdn-assets.alltrails.com/assets/icons/share/embed@2x.png"
                onClick={this.handleEmbedClick}
              />
            </div>
          );
          containerClass = '5-row';
        }
        content = (
          <div>
            <ShareModalDrawer
              title={copyLinkTitle}
              imgLink="https://cdn-assets.alltrails.com/assets/icons/share/link@2x.png"
              onClick={this.handleCopyClick}
              showSuccessIcon={this.state.checkmarks.copy}
            />
            <hr />
            <ShareModalDrawer
              title={smsTitle}
              imgLink="https://cdn-assets.alltrails.com/assets/icons/share/text@2x.png"
              onClick={this.handleTextClick}
              showSuccessIcon={this.state.checkmarks.sms}
            />
            <hr />
            <ShareModalDrawer
              title={StringConstantsMixin.strings.SHARE_MODAL.SEND_EMAIL}
              imgLink="https://cdn-assets.alltrails.com/assets/icons/share/email@2x.png"
              onClick={this.handleEmailClick}
            />
            {embedDiv}
            <hr />
            <ShareModalDrawer
              title={StringConstantsMixin.strings.SHARE_MODAL.QR_CODE}
              imgLink="https://cdn-assets.alltrails.com/assets/icons/share/qr-code@2x.png"
              onClick={this.handleQRCodeClick}
            />
          </div>
        );
    }

    return (
      <Modal handleBackgroundClick={this.handleClose}>
        <div
          id="share-modal"
          className={`share-container no-left-padding no-right-padding col-lg-4 col-md-4 col-sm-4 col-xs-4 ${containerClass} ${this.props.className} ${this.state.openDrawer}`}
          data-testid="share_modal"
        >
          <div className="exit-button-container">
            <button
              className="close"
              onClick={this.handleClose}
              type="button"
              label={StringConstantsMixin.strings.CLOSE}
              data-testid="share_modal_close"
            />
          </div>
          <div className="content-container" data-testid="share_modal_content_container">
            <div className="share-title">
              <h4>{title}</h4>
            </div>
            <div className="share-body">
              {content}
              {this.formatFooter()}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
});

const renderShareModal = (show, handleClose, shareObject, currentUser, languageRegionCode, locale) => {
  if (!show) {
    return null;
  }
  return (
    <ShareModal
      clipboard={clipboardPolyfill}
      currentUser={currentUser}
      languageRegionCode={languageRegionCode}
      locale={locale}
      document={document}
      jQuery={$}
      handleClose={handleClose}
      shareObject={shareObject}
      show={show}
    />
  );
};

export { ShareModal, renderShareModal };
